/**
 * @file index.tsx
 *
 * @fileoverview Shows a desktop link for the main navigation.
 */

import React, { useContext } from 'react';
import { checkHiddenMenu } from '~/jobiqo/components/Header/utils';
import Link from '~/jobiqo/components/Link';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import { AppContextInterface } from '~/jobiqo/models/app';
import { AppContext } from '~/jobiqo/context/app';
import { getTranslatedLink, isUrlActive } from '~/jobiqo/utils/links';
import { HeaderLink } from '~/jobiqo/components/Header/components/Link';
import { MenuLink } from '~/vcl/atoms/08-navigation/01-menu-link';
import NextLink from 'next/link';

export default function LinkDesktop({ link, path }: HeaderLink) {
  const appContext: AppContextInterface = useContext(AppContext);
  const active = isUrlActive(link.url, path);

  return !checkHiddenMenu(link) ? (
    link?.url?.path.substring(0, 4) !== 'http' ? (
      <Link
        asChild
        key={`${link.url.path}--${link.title}`}
        {...getFormattedPageLink(link.url.path)}
      >
        <MenuLink
          linkElement={NextLink}
          href={getTranslatedLink(link.url.path, appContext.locale)}
          {...(link.target ? { target: link.target } : null)}
          active={active}
        >
          {link.title}
        </MenuLink>
      </Link>
    ) : (
      <MenuLink
        key={`${link.url.path}--${link.title}`}
        href={link.url.path}
        {...(link.target ? { target: link.target } : null)}
        active={active}
      >
        {link.title}
      </MenuLink>
    )
  ) : null;
}
